import classNames from 'classnames'

import type { Props } from '..'
import type { MenuType } from 'types'

import Button from 'content-components/_Primatives/Button'
import EmailOfTheDay from '../../EmailOfTheDay'
import FooterLegal from '../../Menus/FooterLegal'

import HeadlineThree from '../../00-Primitives/Headlines/HeadlineThree'
import Menu from 'ui-component-library/components/Menus/Menu'
import MenuItem from 'ui-component-library/components/Menus/MenuItem'
import Paragraph from 'content-components/_Primatives/Paragraph'
import style from './style.scss'

function renderMenuItem({ text, url, target }: MenuType) {
  return (
    <MenuItem key={text} style={style} target={target} text={text} url={url} />
  )
}

function FooterDesktop(props: Props) {
  const {
    className,
    copyrightText,
    findABoxLink,
    legalLinks,
    legalLabelText,
    mainLinks,
    emailOfTheDay,
  } = props
  const { text: findBoxLinkText, url: findBoxLinkUrl } = findABoxLink

  return (
    <footer className={classNames(style.wrapper, className)}>
      <div className={style.innerContent}>
        <div className={style.mainSection}>
          {mainLinks.map(({ text: headlineText, below }) => (
            <div key={headlineText} className={style.menuSection}>
              <HeadlineThree className={style.menuSectionHeadline}>
                {headlineText}
              </HeadlineThree>
              {below && (
                <Menu aria-label={headlineText}>
                  {below.map(renderMenuItem)}
                </Menu>
              )}
            </div>
          ))}
          <section className={style.connectSection}>
            <Button
              aria-label={findBoxLinkText} // Integrates with analytics
              className={style.findBoxButton}
              url={findBoxLinkUrl}
              variant='primaryBlue'
            >
              {findBoxLinkText}
            </Button>
            <EmailOfTheDay {...emailOfTheDay} className={style.emailOfTheDay} />
          </section>
        </div>
        <section className={style.legalSection}>
          <div className={style.emailLegalContainer}>
            <Paragraph className={style.legalText} small>
              {copyrightText}
            </Paragraph>
            <FooterLegal aria-label={legalLabelText} links={legalLinks} />
          </div>
        </section>
      </div>
    </footer>
  )
}

export default FooterDesktop
